import { render, staticRenderFns } from "./PortionSection.vue?vue&type=template&id=38d4e590&scoped=true&"
import script from "./PortionSection.vue?vue&type=script&lang=js&"
export * from "./PortionSection.vue?vue&type=script&lang=js&"
import style0 from "./PortionSection.vue?vue&type=style&index=0&id=38d4e590&lang=scss&scoped=true&"
import style1 from "./PortionSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4e590",
  null
  
)

export default component.exports